import RIcon from '../../assets/student/r_icon.png'
import RIcon1 from '../../assets/student/r_icon1.png'
import BIcon from '../../assets/student/b_icon.png'
import BIcon1 from '../../assets/student/b_icon1.png'
import BIcon2 from '../../assets/student/b_icon2.png'
import BIcon3 from '../../assets/student/b_icon3.png'
import {Toast} from 'vant'

import UserOne from '../../assets/student/user_one.png'
import UserTwo from '../../assets/student/user_two.png'
import UserThree from '../../assets/student/user_three.png'

import img1 from '../../assets/images/person/img(1).png'
import img2 from '../../assets/images/person/img(2).png'
import img3 from '../../assets/images/person/img(3).png'
import img4 from '../../assets/images/person/img(4).png'
import img5 from '../../assets/images/person/img(5).png'
import img6 from '../../assets/images/person/img(6).png'
import img7 from '../../assets/images/person/img(7).png'
import img8 from '../../assets/images/person/img(8).png'
import img9 from '../../assets/images/person/img(9).png'
import img10 from '../../assets/images/person/img(10).png'
import img11 from '../../assets/images/person/img(11).png'
import img12 from '../../assets/images/person/img(12).png'
import img13 from '../../assets/images/person/img(13).png'
import img14 from '../../assets/images/person/img(14).png'
import img15 from '../../assets/images/person/img(15).png'
import img16 from '../../assets/images/person/img(16).png'
import img17 from '../../assets/images/person/img(17).png'
import img18 from '../../assets/images/person/img(18).png'
import img19 from '../../assets/images/person/img(19).png'
import img20 from '../../assets/images/person/img(20).png'
import img21 from '../../assets/images/person/img(21).png'
import img22 from '../../assets/images/person/img(22).png'

const ecgTagOptions = [
  { label: '右流后间隔', value: '1', state: 1 },
  { label: '右流后游离壁', value: '2', state: 1 },
  { label: '右流中间隔', value: '3', state: 1 },
  { label: '右流中游离壁/前窦', value: '4', state: 0 },
  { label: 'AIV前室间静脉', value: '5', state: 1 },
  { label: '右流前间隔', value: '6', state: 1 },
  { label: '右流前游离壁', value: '7', state: 1 },
  { label: '右冠窦RCC', value: '8', state: 1 },
  { label: '左右冠窦之间', value: '9', state: 0 },
  { label: '小叶三角ILT', value: '10', state: 1 },
  { label: '左冠窦LCC', value: '11', state: 1 },
  { label: 'GCV', value: '12', state: 1 },
  { label: 'LVsummit', value: '13', state: 1 },
  { label: 'AMC', value: '14', state: 1 },
  { label: '室上嵴', value: '15', state: 1 },
  { label: '三尖瓣环游离壁8-12点', value: '16', state: 1 },
  { label: '三尖瓣环游离壁11-12点', value: '17', state: 0 },
  { label: '三尖瓣环1点（his旁）', value: '18', state: 1 },
  { label: '三尖瓣环间隔侧2-4点', value: '19', state: 1 },
  { label: '左后分支', value: '20', state: 1 },
  { label: '左后乳头肌', value: '21', state: 1 },
  { label: '二尖瓣环12点-4点', value: '22', state: 1 },
  { label: '左侧his与近端分支', value: '23', state: 1 },
  { label: '左前分支', value: '24', state: 1 },
  { label: '左前乳头肌', value: '25', state: 1 },
  { label: '调节束', value: '26', state: 1 },
  { label: '右室乳头肌', value: '27', state: 1 },
  { label: '右室心尖', value: '28', state: 0 },
  { label: '左室心尖', value: '29', state: 0 },
  { label: '三尖瓣5-7点', value: '30', state: 1 },
  { label: '二尖瓣5-7点', value: '31', state: 1 },
].filter(a => a.state)

const getEcgTagName = (id) => {
  const item = ecgTagOptions.find((item) => item.value === id)
  if (item) return item.label
  return ''
}

const tabList = [
  {
    code: 1,
    name: '交流专区'
  },
  {
    code: 2,
    name: '培训计划'
  },
  {
    code: 3,
    name: '成员'
  },
  {
    code: 4,
    name: '学习内容'
  },
  {
    code: 5,
    name: '直播'
  },
  {
    code: 6,
    name: '作业'
  }
]

const userType = {
  1: '管理员',
  2: '导师',
  3: '学员'
}

const contentType = {
  1: '文献',
  2: '课程',
  3: '病例'
}

const liveType = {
  1: '待开始',
  2: '进行中',
  3: '已结束'
}
const userTypeObj = {
  0: '学员',
  1: '导师',
  2: '管理员'
}

const auditStatusObj = {
  0: '审核中',
  1: '审核通过',
  2: '审核不通过'
}

const dccTypeList = [
  {
    code: 0,
    label: '审核中',
    num: '0'
  },
  {
    code: 1,
    label: '已发布',
    num: '0'
  },
  {
    code: 2,
    label: '待修改',
    num: '0'
  }
]

const searchList = [
  {
    label: '全部',
    icon: null,
    icon1: null,
    code: ''
  },
  // 路由不换啊，代码备注一下2.28业务要求RTC改为NTC
  {
    label: 'NTC专区',
    icon: RIcon,
    icon1: RIcon1,
    code: 1
  },
  {
    label: '病例图文专区',
    icon: BIcon,
    icon1: BIcon1,
    code: 2
  },
  {
    label: '班级',
    icon: BIcon2,
    icon1: BIcon3,
    code: 4
  }
  // {
  //   label: '心电图交流专区',
  //   icon: XIcon,
  //   icon1: XIcon1,
  //   code: 3
  // }
]
// 路由不换啊，代码备注一下2.28业务要求RTC改为NTC
const typeObj = {
  // 1: 'RTC',
  1: 'NTC',
  2: '图文专区',
  3: '心电图交流',
  4: '班级'
}

const CLTypeObj = {
  /*
   * 点赞 kind 类别
   * 1RTC 2图文专区 3心电图交流 4病例交流 5课程
   * 6文献 7班级 8直播 9术式方案 10技术前沿
   * 11专科发展 12诊疗发展
   */
  // 1: 'RTC',
  1: 'NTC',
  2: '图文专区',
  3: '心电图交流',
  4: '病例交流',
  5: '课程',
  6: '文献',
  7: '班级',
  8: '直播',
  9: '术式方案',
  10: '技术前沿',
  11: '专科发展',
  12: '诊疗发展',
  13: '其他'
}

export const myLikeTabs = [
  {kind: 6, label: '文献', icon: img9, iconChecked: img10},
  {kind: 4, label: '病例交流', icon: img3, iconChecked: img4},
  {kind: 5, label: '课程', icon: img5, iconChecked: img6},
  {kind: 1, label: 'NTC', icon: img1, iconChecked: img2},
  {kind: 2, label: '图文专区', icon: img7, iconChecked: img8},
  {kind: 7, label: '班级', icon: img11, iconChecked: img12},
  {kind: 9, label: '术式方案', icon: img13, iconChecked: img14},
  {kind: 10, label: '技术前沿', icon: img15, iconChecked: img16},
  {kind: 11, label: '专科发展', icon: img17, iconChecked: img18},
  {kind: 12, label: '诊疗发展', icon: img19, iconChecked: img20},
  {kind: 13, label: '其他', icon: img21, iconChecked: img22}
]

const commentList = [
  {
    code: 0,
    label: '我的评论'
  },
  {
    code: 1,
    label: '评论我的'
  }
]

const likeList = [
  {
    code: 0,
    label: '我点赞的'
  },
  {
    code: 1,
    label: '点赞我的'
  }
]

const objectCase = {
  '阵发性房颤': 1,
  '持续性房颤': 2,
  '复杂房性心律失常': 3,
  '室上性心律失常': 4,
  '室性心律失常': 5,
  'GREAT PFA': 6,
}
const columnsCase = ['阵发性房颤', '持续性房颤', '复杂房性心律失常', '室上性心律失常', '室性心律失常', 'GREAT PFA']
const liveStatus = {
  0: '未知',
  1: '进行中',
  2: '待开始',
  3: '已完成'
}

const allVideo = ['avi', 'rmvb', 'rm', 'asf', 'divx', 'mpg', 'mpeg', 'mpe', 'wmv', 'mp4', 'mkv', 'vob', 'mov']

const rolesClick = function (roles, userInfo) {
  if (`${roles.peSign}` !== '1' && `${userInfo.memberType}` === '1') {
    Toast('强生员工不支持该功能!')
    return true
  }
}

const roleIsConsumer = function (roles, userInfo) {
  if (`${roles.peSign}` !== '1' && `${roles.tutorSign}` !== '1' && `${userInfo.memberType}` !== '1') {
    Toast('学员不支持该功能!')
    return true
  }
}

const roleIsTutor = function (roles, userInfo) {
  if ((`${roles.roleIsTutor}` === '1') && `${userInfo.memberType}` !== '1') {
    Toast('导师不支持该功能!')
    return true
  }
}
const userAvatar = {
  1: UserOne,
  2: UserThree,
  3: UserTwo
}

const toolbarOptions = [
  // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  ['bold', 'italic', 'underline'],
  // 引用  代码块-----['blockquote', 'code-block']
  // ['blockquote', 'code-block'],
  // // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
  // [{ header: 1 }, { header: 2 }],
  // // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  // [{ list: 'ordered' }, { list: 'bullet' }],
  // // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  // [{ script: 'sub' }, { script: 'super' }],
  // // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
  // [{ indent: '-1' }, { indent: '+1' }],
  // // 文本方向-----[{'direction': 'rtl'}]
  // [{ direction: 'rtl' }],
  // // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
  // [{ size: ['small', false, 'large', 'huge'] }],
  // // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  // [{ header: [1, 2, 3, 4, 5, 6, false] }],
  // // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  // [{ color: [] }, { background: [] }],
  // // 字体种类-----[{ font: [] }]
  // [{ font: [] }],
  // // 对齐方式-----[{ align: [] }]
  // [{ align: [] }],
  // // 清除文本格式-----['clean']
  // ['clean'],
  // // 链接、图片、视频-----['link', 'image', 'video']
  // ['image', 'video']
]

export {
  tabList,
  userType,
  contentType,
  liveType,
  userTypeObj,
  auditStatusObj,
  dccTypeList,
  searchList,
  commentList,
  typeObj,
  likeList,
  objectCase,
  columnsCase,
  CLTypeObj,
  liveStatus,
  rolesClick,
  roleIsConsumer,
  roleIsTutor,
  allVideo,
  userAvatar,
  toolbarOptions,
  ecgTagOptions,
  getEcgTagName
}



// WEBPACK FOOTER //
// ./src/views/RTCZone/data.js